import React from 'react';

import { Icon } from '../icons';

export const CalendarIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 20 20" fill={color} style={style}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 1.66663C12.8452 1.66663 13.125 1.94645 13.125 2.29163V5.62496C13.125 5.97014 12.8452 6.24996 12.5 6.24996C12.1548 6.24996 11.875 5.97014 11.875 5.62496V4.58329H8.75C8.40482 4.58329 8.125 4.30347 8.125 3.95829C8.125 3.61311 8.40482 3.33329 8.75 3.33329H11.875V2.29163C11.875 1.94645 12.1548 1.66663 12.5 1.66663ZM1.875 8.95829C1.875 8.61311 2.15482 8.33329 2.5 8.33329H17.5C17.8452 8.33329 18.125 8.61311 18.125 8.95829V16.4583C18.125 17.724 17.099 18.75 15.8333 18.75H4.16667C2.90102 18.75 1.875 17.724 1.875 16.4583V8.95829ZM3.125 9.58329V16.4583C3.125 17.0336 3.59136 17.5 4.16667 17.5H15.8333C16.4087 17.5 16.875 17.0336 16.875 16.4583V9.58329H3.125Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.16667 4.58337C3.59137 4.58337 3.125 5.04974 3.125 5.62504V8.95837C3.125 9.30355 2.84518 9.58337 2.5 9.58337C2.15482 9.58337 1.875 9.30355 1.875 8.95837V5.62504C1.875 4.35939 2.90101 3.33337 4.16667 3.33337H5.83333C6.17851 3.33337 6.45833 3.6132 6.45833 3.95837C6.45833 4.30355 6.17851 4.58337 5.83333 4.58337H4.16667Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.83325 1.66663C6.17843 1.66663 6.45825 1.94645 6.45825 2.29163V5.62496C6.45825 5.97014 6.17843 6.24996 5.83325 6.24996C5.48807 6.24996 5.20825 5.97014 5.20825 5.62496V2.29163C5.20825 1.94645 5.48807 1.66663 5.83325 1.66663Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7917 3.95837C14.7917 3.6132 15.0716 3.33337 15.4167 3.33337H15.8334C17.0991 3.33337 18.1251 4.35939 18.1251 5.62504V8.95837C18.1251 9.30355 17.8453 9.58337 17.5001 9.58337C17.1549 9.58337 16.8751 9.30355 16.8751 8.95837V5.62504C16.8751 5.04974 16.4087 4.58337 15.8334 4.58337H15.4167C15.0716 4.58337 14.7917 4.30355 14.7917 3.95837Z"
        />
      </g>
    </svg>
  );
};
